import { LumaSplatsThree } from "@lumaai/luma-web";
import { Color, DoubleSide, Mesh, MeshStandardMaterial, PlaneGeometry, Texture, Vector3 } from "three";
import { DemoProps } from ".";

export function SplatTheWorld(props: DemoProps) {
	let { renderer, camera, scene, gui } = props;

	scene.background = new Color('white');

	let splats = new LumaSplatsThree({
		// MIT WPU Globe @krazyykrunal
		source: 'https://lumalabs.ai/capture/58dc5d51-9c6d-470a-8171-4fd20fa9a8ad',
		// we disable full three.js for performance
		enableThreeShaderIntegration: false,
		// particle entrance animation
		particleRevealEnabled: true,
	});

	scene.add(splats);

	// the splats file can provide an ideal initial viewing location
	splats.onInitialCameraTransform = transform => {
		transform.decompose(camera.position, camera.quaternion, new Vector3());
	};

	return {
		dispose: () => {
			// stop worker, free resources
			splats.dispose();
		}
	}
}

